var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./frame.html"] = require( "./frame.html" );




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/index.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./frame.html", false, "src/component/baseui/templates/index.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("frame", t_1);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "type") == "base") {
output += "\n<div class=\"m-alicare\" id=\"alime-wrapper\">\n  ";
output += runtime.suppressValue((lineno = 4, colno = 12, runtime.callWrap(runtime.memberLookup((t_1),"base"), "frame[\"base\"]", context, [runtime.contextOrFrameLookup(context, frame, "name")])), env.opts.autoescape);
output += "\n</div>\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "input") {
output += "\n  ";
output += runtime.suppressValue((lineno = 7, colno = 13, runtime.callWrap(runtime.memberLookup((t_1),"input"), "frame[\"input\"]", context, [runtime.contextOrFrameLookup(context, frame, "send")])), env.opts.autoescape);
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "footer") {
output += "\n  ";
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.memberLookup((t_1),"footer"), "frame[\"footer\"]", context, [])), env.opts.autoescape);
output += "\n";
;
}
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/index.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/index.html
// module id = 177
// module chunks = 0 1